import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { param } from "jquery";
import { Observable } from "rxjs";
import { AskGPT } from "src/app/GlobalVariables";

@Injectable({
    providedIn: 'root'
})

export class OpenAIService {
    private http = inject(HttpClient);

    EmailImprovementPrompt: string = `
    The text above is the user's input. 
    - If it is plain text description, generate a new professional email template using only table-based HTML structure.  
    - If it already contains HTML, improve and clean that HTML to match the requirements below.  

    The output must be only valid HTML code inside<html>...</html> tags, nothing else.  
    Do not include explanations, markdown formatting, or HTML comments.

    Requirements:
    - Use inline CSS only.  
    - Do not make the layout responsive.The table structure and content must remain exactly the same on all devices.  
    - Treat the email like a vertical rectangle phamplet / flyer.  
    - Include a header section with logo, main body with heading and paragraph, and a call - to - action button.  
    - Include a footer with company details or unsubscribe link.  
    - Text and images should scale within the fixed area, but no rearrangement of tables, columns, or rows.  

    Return only the HTML.Do not include explanations or markdown formatting.`

    AskGPT(query: string): Observable<string> {
        return this.http.get<string>('https://apig.advinsoftwares.com/AI/OA/GPT/AskChatGPT', {
            params: { query: query }
        })
    }

    GenerateEmailTemplate(query: string): Observable<string> {
        query = query + ' ' + this.EmailImprovementPrompt
        return this.http.get<string>('https://apig.advinsoftwares.com/AI/OA/GPT/AskChatGPT?query=', {
            params: { query }, responseType: 'text' as 'json'
        })
    }
}